"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_MAX_AGE_HOURS = exports.SESSION_INACTIVITY_HOURS = exports.SessionStatus = void 0;
var SessionStatus;
(function (SessionStatus) {
    SessionStatus["ACTIVE"] = "active";
    SessionStatus["REVOKED"] = "revoked";
    SessionStatus["DELETED"] = "deleted";
})(SessionStatus || (exports.SessionStatus = SessionStatus = {}));
/** Server-side session lifetime limits (hours). */
exports.SESSION_INACTIVITY_HOURS = {
    standard: 1,
    rememberMe: 24 * 2,
};
exports.SESSION_MAX_AGE_HOURS = {
    standard: 24,
    rememberMe: 24 * 30,
};
//# sourceMappingURL=ISession.js.map